import React from 'react';
import PageHero from '../components/PageHero';
import AnimatedSection from '../components/AnimatedSection';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function About() {
  return (
    <div className="bg-white">
      <PageHero 
        title="Unmasking Our Legacy" 
        description="We are the silent guardians behind the world's most resilient enterprises. Discover the foundation of our uncompromising methodology."
        image="https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=2070&auto=format&fit=crop"
      />

      <section className="py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
            <AnimatedSection>
              <div className="w-16 h-2 bg-red-600 mb-8"></div>
              <h2 className="text-4xl md:text-5xl font-extrabold text-zinc-900 mb-8 tracking-tight">We Don't Follow Standards. <br/>We Set Them.</h2>
              <p className="text-zinc-600 text-xl mb-6 leading-relaxed font-light">
                Founded by industry contrarians, Insurance Secrets was built on a singular truth: standard policies are designed to protect the insurer, not the insured.
              </p>
              <p className="text-zinc-600 text-xl leading-relaxed font-light">
                We dismantled the traditional brokerage model. We employ forensic risk analysts, legal scholars, and underwriting savants to craft bespoke safety nets. When you partner with us, you are guarded by an elite syndicate dedicated solely to your preservation.
              </p>
            </AnimatedSection>
            
            <AnimatedSection delay={0.2} className="relative">
              <div className="absolute inset-0 bg-red-600 translate-x-4 translate-y-4 rounded-3xl"></div>
              <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=2070&auto=format&fit=crop" alt="Team" className="relative z-10 rounded-3xl shadow-2xl w-full h-[500px] object-cover grayscale hover:grayscale-0 transition-all duration-700" />
            </AnimatedSection>
          </div>
        </div>
      </section>

      <section className="py-32 bg-zinc-50 border-t border-zinc-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <AnimatedSection className="text-center max-w-3xl mx-auto mb-20">
            <h2 className="text-4xl md:text-5xl font-extrabold text-zinc-900 tracking-tight">The Pillars of Secrecy</h2>
          </AnimatedSection>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {[
              { icon: FiIcons.FiLock, title: "Absolute Discretion", desc: "Your vulnerabilities are heavily classified. We operate with vault-like security." },
              { icon: FiIcons.FiCrosshair, title: "Surgical Precision", desc: "No bloated policies. We excise the fat and fortify the vital arteries of your business." },
              { icon: FiIcons.FiZap, title: "Ruthless Execution", desc: "In the event of a claim, we strike fast and hard to ensure immediate restitution." }
            ].map((val, i) => (
              <AnimatedSection key={i} delay={i * 0.1}>
                <motion.div whileHover={{ y: -10 }} className="bg-white p-10 rounded-3xl shadow-xl shadow-zinc-200/50 border border-zinc-100 text-center h-full">
                  <div className="w-20 h-20 mx-auto bg-red-50 text-red-600 rounded-full flex items-center justify-center text-3xl mb-8">
                    <SafeIcon icon={val.icon} />
                  </div>
                  <h3 className="text-2xl font-bold text-zinc-900 mb-4 tracking-tight">{val.title}</h3>
                  <p className="text-zinc-600 font-light text-lg">{val.desc}</p>
                </motion.div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}